import { type FC, type SVGProps } from 'react';

const EmptyReport: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width={403} height={172} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M332.722 162.923c.309-.515.593-1.025.925-1.588 2.152-5.893 1.381-9.527.409-11.732-3.841-8.608-14.34-13.22-37.442-16.955-1.69-.261-12.242-3.586-16.391-13.682-2.716-6.556-1.186-13.113-.101-17.055 3.687-13.937 11.933-15.117 16.338-26.588 3.64-9.485 3.486-22.954-3.634-32.996-8.892-12.603-25.817-15.674-38.266-13.167-12.189 2.46-20.589 10.713-24.792 15.728a73.69 73.69 0 0 0-13.635-20.541C198.971 6.058 172.698-2.597 148.825.682c-26.677 3.687-43.228 21.311-51.528 30.174C50.737 80.599 81.501 161.335.5 171.353h402.501c-17.726-2.537-45.535-5.359-70.279-8.43Z'
      fill='#00628B'
    />
    <path
      d='M279.721 159.692c-2.098 4.358-5.786 6.664-7.374 7.707a24.707 24.707 0 0 1-10.013 3.415 22.39 22.39 0 0 1-2.715.148c-27.406 0-40.721.415-50.609.415-23.049 0-59.72-.107-108.076-.107-6.657-3.586-34.881-20.642-45.896-57.734-.765-2.508-14.95-53.739 10.706-83.504 1.59-1.844 17.625-19.978 34.473-15.728 17.784 4.458 20.185 29.92 41.852 35.042 9.219 2.205 16.955-.463 19.563-1.382 21.342-7.582 21.567-30.381 40.365-36.63 9.728-3.225 22.486-.51 29.76 8.81 10.19 13.041 8.4 35.302-.593 48.978-5.431 8.199-11.116 10.398-14.293 20.85-1.126 3.687-3.379 11.577.107 20.031 4.914 11.856 17.31 15.727 19.26 16.035 22.942 3.688 40.875 9.219 43.869 19.877 2.43 7.992-.386 13.777-.386 13.777Z'
      fill='#F6CA65'
    />
    <path
      d='M119.145 151.037c-5.691-.818-7.428-3.794-13.676-3.586-5.074.154-5.993 2.205-12.04 3.586-3.278.771-13.315 3.071-18.852-1.381-6.52-5.335-6.657-16.397-1.89-24.335 5.785-9.533 14.393-13.985 17.31-23.001 1.233-3.794.462-5.229.717-10.76.871-19.367 10.042-40.626 17.008-40.311 2.561.1 4.304 3.07 6.711 7.22 3.325 5.638 3.325 9.687 5.335 20.749 1.642 8.862 2.407 13.32 4.256 18.033 2.662 6.918 4.66 8.045 8.448 15.064 5.685 10.398 12.04 22.029 7.707 30.12-3.522 6.45-13.659 9.657-21.034 8.602Z'
      fill='#3ABD9D'
    />
    <path
      d='M98.758 171.27s8.709-19.415 7.013-38.112c-1.695-18.698-3.687-14.957-1.019-31.556 2.667-16.599 1.227-28.995 1.227-28.995s5.892 22.693 2.152 35.807c-3.741 13.113 5.685 18.377 5.021 38.782-.664 20.404.047 24.074.047 24.074h-14.44Z'
      fill='#465477'
    />
    <path
      d='m105.108 127.318-18.745-5.228 19.408 11.222-.663-5.994ZM106.904 119.274l14.085-8.4-14.085 2.685v5.739-.024Z'
      fill='#465477'
    />
    <path
      d='M62.188 143.046a24.187 24.187 0 0 1-22.348-14.93 24.182 24.182 0 1 1 22.348 14.93Z'
      fill='#8FDD66'
    />
    <path
      d='m61.571 126.008-18.852-5.222 19.468 11.216-.616-5.994ZM62.188 118.895l14.132-8.4-14.132 5.376v3.024Z'
      fill='#465477'
    />
    <path d='m61.725 105.444 4.506 65.802h-8.092l3.586-65.802Z' fill='#465477' />
  </svg>
);

export default EmptyReport;
